import type { IconSvgObject } from './types';

const Progress04Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 4.5C13.4834 4.5 14.9334 4.93987 16.1668 5.76398C17.4001 6.58809 18.3614 7.75943 18.9291 9.12987C19.4968 10.5003 19.6453 12.0083 19.3559 13.4632C19.0665 14.918 18.3522 16.2544 17.3033 17.3033C16.2544 18.3522 14.918 19.0665 13.4632 19.3559C12.0083 19.6453 10.5003 19.4968 9.12987 18.9291C7.75943 18.3614 6.58809 17.4001 5.76398 16.1668C4.93987 14.9334 4.5 13.4834 4.5 12H12V4.5Z", fill: "currentColor", key: "1" }]
];

export default Progress04Icon;
